import { render, staticRenderFns } from "./CourseSettings.vue?vue&type=template&id=38e68edc"
import script from "./CourseSettings.vue?vue&type=script&lang=js"
export * from "./CourseSettings.vue?vue&type=script&lang=js"
import style0 from "./CourseSettings.vue?vue&type=style&index=0&id=38e68edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports